export default {
  RESET_PASSWORD: 'reset_password',
  DEACTIVATE: 'deactivate',
  ACTIVATE: 'activate',
  SET_ACCESS: 'set_access',
  CHANGE_ATTRIBUTES: 'change_attributes',
};
